import {MetaData} from "@cm/template-nodes"
import {z} from "zod/v4-mini"

export const dimensionPathName = "Dimensions"

export const panelPathName = "Panels & Borders"
export const topPanelPathName = "Top Panel"
export const stackPathName = "Stack"
export const bottomPanelPathName = "Bottom Panel"

export const seamPathName = "Seams"

export type PathElement = {
    name: string
    rank: number
    path?: PathElement
}

export const pathElementSchema: z.ZodMiniType<PathElement, PathElement> = z.lazy(() =>
    z.object({
        name: z.string(),
        rank: z.number(),
        path: z.optional(pathElementSchema),
    }),
)

export const mattressIoMetaDataSchema = z.object({
    uiPaths: z.array(pathElementSchema),
    rank: z.number(),
})

export type MattressMaterialInputParams = z.infer<typeof mattressIoMetaDataSchema>

export const mattressNumberInputMetaDataSchema = z.extend(mattressIoMetaDataSchema, {
    min: z.number(),
    max: z.number(),
})
export type MattressNumberInputMetaData = z.infer<typeof mattressNumberInputMetaDataSchema>

export function createPath(name: string, rank: number, path?: PathElement): PathElement {
    return path ? {name, rank, path} : {name, rank}
}

function mattressNumberInputParams(paths: PathElement[], min: number, max: number, rank: number): MattressNumberInputMetaData {
    return {uiPaths: paths, min, max, rank}
}

export function numberInputMetaData(paths: PathElement[], min: number, max: number, rank: number): MetaData {
    return new MetaData({parameters: mattressNumberInputParams(paths, min, max, rank)})
}

function mattressMaterialInputParams(paths: PathElement[], rank: number): MattressMaterialInputParams {
    return {uiPaths: paths, rank}
}

export function materialInputMetaData(paths: PathElement[], rank: number): MetaData {
    return new MetaData({parameters: mattressMaterialInputParams(paths, rank)})
}

export function uiPathMetaData(paths: PathElement[], rank: number): MetaData {
    return new MetaData({parameters: {uiPaths: paths, rank}})
}
